module.exports = __webpack_public_path__ + "ebdd8fac39cbbd8135c7b6282dde697c.jpg";